import { render, staticRenderFns } from "./WDRecordList.vue?vue&type=template&id=c2b70e4e&scoped=true&"
import script from "./WDRecordList.vue?vue&type=script&lang=js&"
export * from "./WDRecordList.vue?vue&type=script&lang=js&"
import style0 from "./WDRecordList.vue?vue&type=style&index=0&id=c2b70e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b70e4e",
  null
  
)

export default component.exports